import {
    INIT_LIBRARY_REQUEST,
    ADD_LIBRARY,
    ERROR_LIBRARY_REQUEST,
    ERROR_ADD_LIBRARY_REQUEST
} from './action';

const initialState = {
    data: [],
    error: null,
    isLoading: false,
};

const libraryReducer = (state = initialState, action) => {

    switch (action.type) {
        case INIT_LIBRARY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };


        case ADD_LIBRARY:
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                error: null,
            };

        case ERROR_LIBRARY_REQUEST:
            return {
                ...state,
                data: [],
                isLoading: false,
                error: action.payload,
            };

        case ERROR_ADD_LIBRARY_REQUEST:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };


        default:
            return state;
    }
};

export default libraryReducer;
